module.exports = __webpack_public_path__ + "assets/img/report-act-bg-4.0006871e.png";